import ReactSelect from 'react-select';
import { InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const BuildingAntiquity = ({
  handleChangeCaracObj,
  errors,
  touched,
  values
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'A estrenar' },
    { value: 2, label: 'Entre 1 y 10 años' },
    { value: 3, label: 'Entre 10 y 50 años' },
    { value: 4, label: 'Antiguo' }
  ];
  return (
    <div>
      <label>Antigüedad del Edificio</label>
      <ReactSelect
        name="buildingAntiquity"
        placeholder="-- Seleccione la Antigüedad --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj(
            'buildingAntiquity',
            e?.value && Number(e.value)
          );
        }}
      ></ReactSelect>
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger mt-1">{errors.type}</label>
      )}
    </div>
  );
};

BuildingAntiquity.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
